import { Box, Link } from "@mui/material";

import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import {
  icons,
  logos,
} from "../../../../../stack/environment/icons/iconExport";
const AsanaTicket = ({ ticket }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();

  const handleAsanaClick = (e) => {
    e.stopPropagation();
    trackEvent(
      `User clicked on Asana ticket for control: ${ticket.control_id}`
    );
  };

  return (
    <Box>
      <Link
        variant="caption"
        href={ticket?.asana_details?.task_link}
        target="_blank"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: "1px solid " + colors.grey_300,
          borderRadius: "14px",
          padding: "2px 6px",
        }}
        onClick={handleAsanaClick}
      >
        <SvgToIcon IconLogo={logos.AsanaLogo} width={16} height={16} />
        <SvgToIcon IconLogo={icons.ExternalLinkIcon} width={14} />
      </Link>
    </Box>
  );
};

export default AsanaTicket;
